const Transformation = () =>
  import('@/views/main/inspect/transformation/Transformation.vue')
export default {
  path: '/main/inspect/transformation',
  name: 'Transformation',
  component: Transformation,
  children: []
}
